import { render, staticRenderFns } from "./Keuangan.vue?vue&type=template&id=cb53fd54&"
import script from "./Keuangan.vue?vue&type=script&lang=js&"
export * from "./Keuangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports